import { useRef, useState } from 'react';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import 'react-multi-date-picker/styles/layouts/mobile.css';
import persian from 'react-date-object/calendars/persian';
import persianLocale from 'react-date-object/locales/persian_fa';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import TimePickerStyles from './TimePickerStyles';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSearchParams } from 'react-router-dom';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';

/**
 * @param {{
 *   initDay: number,
 *   lastDay: number,
 *   onApply?: (fromUnix: number | null, toUnix: number | null) => void,
 * }} props
 */
export default function TimePicker({ initDay, lastDay, onApply }) {
  const datePickerRef = useRef(null);
  const [values, setValues] = useState([
    new DateObject({ date: initDay * 1000 }),
    new DateObject({ date: lastDay * 1000 })
  ]);
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);

  return (
    <div id="timepicker-wrapper" className="w-100">
      <style>{`
        #timepicker-wrapper .rmdp-container{
        display:${isMdUp ? 'inline-block' : 'block'} !important;
        }
        #timepicker-wrapper .rmdp-action-buttons{
        display:none !important;
        }
        `}</style>
      {isMdUp ? (
        <DatePicker
          value={values}
          onChange={setValues}
          ref={datePickerRef}
          range
          className="custom-calendar rmdp-prime w-100 bg-custom"
          calendar={persian}
          dateSeparator=" ~ "
          locale={persianLocale}
          format="YYYY-MM-DD"
          style={{ padding: 4 }}
          render={(value, openCalendar) => (
            <div className="position-relative w-100">
              <Form.Control
                size="sm"
                onClick={openCalendar}
                value={value.toString().toPersianDigit()}
                className="ps-4 w-100"
                readOnly
                style={{ direction: 'rtl' }}
              />
              <FontAwesomeIcon
                style={{
                  color: getColor('navbar-vertical-default-link-active-color')
                }}
                icon="calendar-alt"
                className="position-absolute top-50 translate-middle-y ms-2"
              />
            </div>
          )}
          buttons
          plugins={[<DatePanel sort="date" key="DatePanel" />]}
        >
          <SubmitButtons
            datePickerRef={datePickerRef}
            values={values}
            onApply={onApply}
          />
        </DatePicker>
      ) : (
        <DatePicker
          value={values}
          onChange={setValues}
          ref={datePickerRef}
          range
          className="custom-calendar rmdp-mobile bg-custom"
          calendar={persian}
          dateSeparator=" ~ "
          locale={persianLocale}
          format="YYYY-MM-DD"
          style={{ padding: 4 }}
          render={(value, openCalendar) => (
            <div className="position-relative w-100">
              <Form.Control
                size="sm"
                onClick={openCalendar}
                value={value.toString().toPersianDigit()}
                className="ps-4 w-100"
                readOnly
                style={{ direction: 'rtl' }}
              />
              <FontAwesomeIcon
                style={{
                  color: getColor('navbar-vertical-default-link-active-color')
                }}
                icon="calendar-alt"
                className="position-absolute top-50 translate-middle-y ms-2"
              />
            </div>
          )}
          buttons
        >
          <SubmitButtons
            datePickerRef={datePickerRef}
            values={values}
            onApply={onApply}
          />
        </DatePicker>
      )}
      <TimePickerStyles />
    </div>
  );
}

const SubmitButtons = ({ values, datePickerRef, onApply }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <div className="d-flex gap-2 p-2 fs--2">
      <Button
        size="sm"
        variant="falcon-primary"
        onClick={() => {
          const [fromDate, toDate] = values;
          const fromUnix = fromDate ? fromDate.toUnix() : null;
          const toUnix = toDate ? toDate.toUnix() : null;

          if (onApply) {
            onApply(fromUnix, toUnix);
          } else {
            const currentParams = Object.fromEntries(searchParams.entries());
            const newParams = {
              ...currentParams,
              from_date: fromUnix,
              to_date: toUnix
            };
            setSearchParams(newParams);
          }

          datePickerRef.current.closeCalendar();
        }}
      >
        اعمال
      </Button>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => datePickerRef.current.closeCalendar()}
      >
        لغو
      </Button>
    </div>
  );
};
